<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-dollar"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'contador.comissoes.titulo_pagina' | translate }}</h1>
    <p class="header-subtitle">{{ 'contador.comissoes.subtitulo_pagina' | translate }}</p>
  </div>
</div>

<div class="tabs-container">
  <p-tabView>

    <!-- ================= Aba 1: Repasse de Comissoes ================= -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-dollar tab-icon"></i>
        <span>{{ 'contador.comissoes.aba_repasse' | translate }}</span>
      </ng-template>
      <app-repasse-comissoes></app-repasse-comissoes>
    </p-tabPanel>

    <!-- ================= Aba 2: Historico de Pagamentos ================= -->
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-history tab-icon"></i>
        <span>{{ 'contador.comissoes.aba_historico' | translate }}</span>
      </ng-template>
      <app-historico-pagamentos></app-historico-pagamentos>
    </p-tabPanel>

  </p-tabView>
</div>
